module.exports = __webpack_public_path__ + "img/background.8441c19f.jpg";